import { render } from "./SchoolCategoryForm.vue?vue&type=template&id=50bba4e3&scoped=true"
import script from "./SchoolCategoryForm.vue?vue&type=script&lang=js"
export * from "./SchoolCategoryForm.vue?vue&type=script&lang=js"

import "./SchoolCategoryForm.vue?vue&type=style&index=0&id=50bba4e3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bba4e3"]])

export default __exports__